export const NEW_MESSAGE = 'NEW_MESSAGE';
export const NOT_CHATTING = 'NOT_CHATTING';
export const CHAT_STARTED = 'CHAT_STARTED';
export const CHAT_ENDED = 'CHAT_ENDED';
export const SURVEY_SUBMITTED = 'SURVEY_SUBMITTED';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const NEW_USER = 'NEW_AGENT';
export const OWN_DATA_RECEIVED = 'OWN_DATA_RECEIVED';
export const CHANGE_CHAT_SERVICE = 'CHANGE_CHAT_SERVICE';
export const RATE_GOOD = 'RATE_GOOD';
export const RATE_BAD = 'RATE_BAD';
export const CHAT_RATED = 'CHAT_RATED';
export const CHAT_SID = 'CHAT_SID';
export const CHAT_ACTIVITYID = 'CHAT_ACTIVITYID';
export const CHAT_TOKEN = 'CHAT_TOKEN';
export const CHAT_UUID = 'CHAT_UUID';
export const AGENT_START_TYPING = 'AGENT_START_TYPING';
export const AGENT_STOP_TYPING = 'AGENT_STOP_TYPING';
export const AGENT_STATUS = 'AGENT_STATUS';

export const newMessage = ({ id, authorId, customId, text, buttons, title, imageUrl, timestamp }) => ({
	type: NEW_MESSAGE,
	payload: {
		id,
		authorId,
		customId,
		text,
		buttons,
		title,
		imageUrl,
		timestamp,
	},
})

export const sendMessage = ({ text, customId,date }) => ({
	type: SEND_MESSAGE,
	payload: {
		text,
		customId: customId || String(Math.random()),
		timestamp: date || new Date(),
	},
})

export const receiveMessage = ({ text, customId,date,image,type }) => ({
	type: RECEIVE_MESSAGE,
	payload: {
		text,
		customId: customId || String(Math.random()),
		timestamp: date || new Date(),
		imageUrl:image?image:false,
		type:type?type:undefined
	}
});

export const newUser = ({ id, name, email, avatarUrl }) => ({
	type: NEW_USER,
	payload: {
		id,
		name,
		email,
		avatarUrl,
	},
})

export const ownDataReceived = ({ id }) => ({
	type: OWN_DATA_RECEIVED,
	payload: {
		id,
	},
})

export const chatInit = () => ({
	type: NOT_CHATTING
});

export const chatEnded = () => ({
	type: CHAT_ENDED,
});

export const surveySubmitted = () => ({
	type: SURVEY_SUBMITTED
});

export const chatStarted = ({ chatId }) => ({
	type: CHAT_STARTED,
	payload: {
		chatId,
	},
})

export const changeChatService = ({ chatService }) => ({
	type: CHANGE_CHAT_SERVICE,
	payload: {
		chatService,
	},
})

export const rateGood = () => ({
	type: RATE_GOOD,
})

export const rateBad = () => ({
	type: RATE_BAD,
})

export const chatRated = ({ rate }) => ({
	type: CHAT_RATED,
	payload: {
		rate,
	},
})

export const setSid = (sid) => ({
	type: CHAT_SID,
	payload: {
		sid: sid
	}
});
export const setActivityID = (activityid) => ({
	type: CHAT_ACTIVITYID,
	payload: {
		activityid: activityid
	}
});

export const setToken = (token) => ({
	type: CHAT_TOKEN,
	payload: {
		token: token
	}
});

export const setUUID = (uid) => ({
	type: CHAT_UUID,
	payload: {
		uid: uid
	}
});

export const onAgentStartTyping = () => ({
	type: AGENT_START_TYPING
});

export const onAgentStopTyping = () => ({
	type: AGENT_STOP_TYPING
});

export const setAgentStatus = (payload) => ({
	type: AGENT_STATUS,
	payload: payload
})